import React, { memo } from 'react';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var SkeletonBasic = /*#__PURE__*/memo(function (_ref) {
  var className = _ref.className,
    testName = _ref.testName;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('skeleton', className),
    "data-component": testName
  });
});